export const loadAuthView = view => () =>
  import(`@/components/views/auth/${view}.vue`);
export const loadAdminView = view => () =>
  import(`@/components/views/admin/${view}.vue`);
export const loadClubView = view => () =>
  import(`@/components/views/club/${view}.vue`);
export const loadLibView = view => () =>
  import(`@/components/libs/${view}.vue`);
export const loadSharedView = view => () =>
  import(`@/components/shared/${view}.vue`);
export const loadCommmonView = view => () =>
  import(`@/components/views/common/${view}.vue`);
export const loadLeagueView = view => () =>
  import(`@/components/views/league/${view}.vue`);
export const loadRegisterView = view => () =>
  import(`@/components/views/register/${view}.vue`);
